/**
 * Shared CSS cursor for corner rotation (curved turner arrow).
 * Hotspot is the icon center; falls back to {@link grab} if the SVG fails.
 */
export const ROTATE_CURSOR = buildRotateCursorCss();
export const BLUEPRINT_ROTATE_CURSOR = ROTATE_CURSOR;

/**
 * Build a high-contrast curved-arrow cursor as a data-URL SVG.
 */
function buildRotateCursorCss(): string {
  // White stroke under black so the glyph stays visible on light and dark plans.
  const svg = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M17.2 8.2A6.2 6.2 0 1 0 18.5 12.4" stroke="#ffffff" stroke-width="3.6" stroke-linecap="round"/>
      <path d="M17.2 8.2A6.2 6.2 0 1 0 18.5 12.4" stroke="#111111" stroke-width="1.8" stroke-linecap="round"/>
      <path d="M14.6 4.8 L17.2 8.2 L13.8 9" stroke="#ffffff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.6 4.8 L17.2 8.2 L13.8 9" stroke="#111111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  );
  return `url("data:image/svg+xml,${svg}") 12 12, grab`;
}
